<template>
  <div>
    <div class="form-request">
      
      <div :class="typeMessage" role="alert" v-if="message != ''">
        {{message}}
      </div>

      <template v-if="!done">

        <div class="content-tab">
          <p id="title-forms">Cuéntanos sobre tus experiencias educativas formales más significativas. Es fundamental que adjuntes los certificados que te solicitamos a continuación por cada referencia académica que ingreses</p>
        </div>

        <div class="row">
          <div class="col-sm-6">
            <upload-multiple-file :project="project" :viewFiles="true" :academic_reference="academic_reference" :propmessage="['Fotocopia de tu acta de grado', 'Diploma']" :academicReferenceArchives.sync="academicReferenceArchives" type_document_academic='document' :img="imgDoc" textSection="Documentos"/>        
          </div>
          <div class="col-sm-6">
            <upload-multiple-file :project="project" :academic_reference="academic_reference" :propmessage="['Exámenes de estado (opcional)', 'homologación de títulos (opcional)']" :academicReferenceArchives.sync="academicReferenceArchives" type_document_academic='certified' :img="imgCert" textSection="Certificados"/>        
          </div>                    
        </div>
        <div class="col-sm-4">
          <p class="myLabelTabs" for="observations">Nivel educativo</p>
          <select class="select-request" v-model="academic_reference.level">
            <option disabled value="">Seleccione el nivel de la referencia académica</option>
            <option v-for="(level, index) in levels" :key="index" v-bind:value="level.id">{{level.name}}</option>
          </select>                  
        </div>

        <div class="col-sm-4">
          <p class="myLabelTabs" for="observations">Nombre institución</p>
          <input class="inputRequest" type="text" v-model="academic_reference.name_institution">
        </div>

        <div class="col-sm-4">
          <p class="myLabelTabs" for="observations">Título obtenido</p>
          <input class="inputRequest" type="text" v-model="academic_reference.name_title">        
        </div>

        <div class="col-sm-4">
          <p class="myLabelTabs" for="observations">Fecha de graduación</p>
          <input class="select-request" type="date" v-model="academic_reference.date_graduation">        
        </div>

        <div class="col-sm-4">
          <p class="myLabelTabs" for="observations">Pais</p>
          <select class="select-request" v-model="country_id">
            <option disabled value="">Seleccione una ciudad</option>
            <option v-for="(country, index) in countries" :key="index" v-bind:value="country.id">{{country.name}}</option>
          </select>                          
        </div>

        <div class="col-sm-4">
          <p class="myLabelTabs" for="observations">Ciudad</p>
          <select class="select-request" v-model="academic_reference.city_id">
            <option disabled value="">Seleccione una ciudad</option>
            <option v-for="(city, index) in cities" :key="index" v-bind:value="city.id">{{city.name}}</option>
          </select>                          
        </div>        

        <div class="row">
          <div class="col-sm-4">
            <b-button class="button-save button-form-steps save-academic" @click.prevent="save">{{textButton}}</b-button>
          </div>      
        </div>        
      </template>

      <div class="content-tab" v-else>
        <p id="title-forms">La información ha sido diligenciada</p>
      </div>      

      <div class="row">

        <table class="table table-condensed table-academic-tab" id="table-academic-references" v-if="width > 768">
          <thead>
              <tr>
                <th class="header-column-table">Nivel educativo</th>
                <th class="header-column-table">Institución</th>
                <th class="header-column-table">Título</th>
                <th class="header-column-table">Graduación</th>
                <th class="header-column-table">Ciudad</th>
                <th class="header-column-table" v-if="!done">Editar</th>
                <th class="header-column-table" v-if="!done">Eliminar</th>
                <th class="header-column-table">Adjuntos</th>
              </tr>
          </thead>
          <tbody>
            <tr v-for="(academic_reference_iterator, index) in academic_references_local" :key="academic_reference_iterator.id">
              <template v-if="academic_reference_iterator.name_institution != null && academic_reference_iterator.name_institution != ''">
                <td class="myLabelTabs">{{academic_reference_iterator.level | levelName }}</td>
                <td class="myLabelTabs">{{academic_reference_iterator.name_institution}}</td>
                <td class="myLabelTabs">{{academic_reference_iterator.name_title}}</td>
                <td class="myLabelTabs">{{academic_reference_iterator.date_graduation}}</td>
                <td class="myLabelTabs">{{getNameCity(academic_reference_iterator.city_id)}}</td>
                <td v-if="!done">
                  <button @click.prevent="edit(academic_reference_iterator)" type="button" class="mybuttonAction"><i class="far fa-edit"></i></button>
                </td>            
                <td v-if="!done">
                  <button @click.prevent="deleteAcademicReference(academic_reference_iterator, index)" type="button" class="mybuttonAction"><i class="far fa-trash-alt"></i></button>
                </td>
                <td>
                  <button @click.prevent="viewFiles(academic_reference_iterator)" type="button" class="mybuttonAction"><i class="far fa-eye"></i></button>
                </td>         
              </template>
            </tr>
          </tbody>
        </table>
        <ul class="list-group" v-else v-for="(academic_reference_iterator) in academic_references_local" :key="academic_reference_iterator.id">
          <li class="list-group-item active header-list">
            {{academic_reference_iterator.name_institution}}
          </li>
          <li class="list-group-item item-list">Nivel educativo: {{academic_reference_iterator.level | levelName }}</li>
          <li class="list-group-item item-list">Título: {{academic_reference_iterator.name_title}}</li>
          <li class="list-group-item item-list">Graduación: {{academic_reference_iterator.date_graduation}}</li>
          <li class="list-group-item item-list">Ciudad: {{getNameCity(academic_reference_iterator.city_id)}}</li>
          <li class="list-group-item item-list" v-if="!done">
            <div class="btn-group" role="group" aria-label="Basic example">
              <button @click.prevent="edit(academic_reference_iterator)" type="button" class="button-save"><i class="far fa-edit"></i>Editar</button>
              <button @click.prevent="deleteAcademicReference(academic_reference_iterator, index)" type="button" class="button-save"><i class="far fa-trash-alt"></i>Eliminar</button>              
            </div>            
          </li>
        </ul>        

        <div :class="typeMessage" role="alert" v-if="message != ''">
          {{message}}
        </div>

      </div>      
    </div>

    <!--Modal-->
    <div>
      <!-- Button trigger modal -->
<button type="button" style="visibility:hidden;" id="modalButton" class="btn btn-primary" data-toggle="modal" data-target="#exampleModalLong"></button>
<!-- Modal -->
<div class="modal fade" id="exampleModalLong" tabindex="-1" role="dialog" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
  <div class="modal-dialog modal-xl" style="width:1200px;" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLongTitle">Archivos Adjuntos</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" style="height: 528px;">
        <div class="row">
          <div class="col-sm-12">
            <div :class="typeMessage" role="alert" v-if="message != ''">
              {{message}}
             </div>
          </div>
          <div class="col-sm-12">
            <upload-multiple-file v-on:update-files="updateFiles()" :project="project" :viewFiles="false" :academic_reference="academic_reference_files" :propmessage="['Fotocopia de tu acta de grado', 'Diploma']" :academicReferenceArchives.sync="academicReferenceArchives" type_document_academic='document' :img="imgDoc" textSection="Documentos"/>        
          </div>                    
        </div>
        <div class="col-sm-12" style="justify-content: center; text-align: center; display: flex;">
          <table>
            <thead>
              <tr>
                <th >Nombre</th>
                <th >Eliminar</th>
              </tr>
            </thead>
            <tbody v-if="viewFiles">
              <tr v-for="(file, index) in files_by_reference" :key="file.id">
                <td style="padding-right:17px;">{{file.title}}</td>
                <td><button @click.prevent="deleteArchive(file.id,index)" type="button" class="mybuttonAction"><i class="far fa-trash-alt"></i></button></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cerrar</button>
      </div>
    </div>
  </div>
</div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import UploadMultipleFile from './../../own/upload-multiple-file.vue'
import { eventBus } from './../../../application'
export default {
  name: "AcademicForm",
  props: ['project', 'assignments', 'academic_references'],
  data() {
    return {
      country_id:0,
      countries:[],
      cities:[],
      files:[],
      academic_reference_files:{},
      files_by_reference:[],
      width: null,
      textButton: 'Agregar',
      typeMessage: '',
      message: '',
      academic_references_local: this.academic_references,
      academic_reference: {},
      academic_types: [
        { id: 1, name: "elemental" },
        { id: 2, name: "superior" }
      ],
      levels: [
        { id: 0, name: "Primaria" },
        { id: 1, name: "Bachiller" },
        { id: 2, name: "Profesional Universitario" },
        { id: 3, name: "Técnico Profesional" },
        { id: 4, name: "Otro" },
        { id: 5, name: "Tecnólogo" },
        { id: 6, name: "Especialista" },
        { id: 7, name: "Maestria" },
        { id: 8, name: "Doctorado" }
      ],
      academicReferenceArchives: null,
      imgDoc: 'https://res.cloudinary.com/dhcti0lrk/image/upload/v1602709289/Page_2_no1qob.png',
      imgCert: 'https://res.cloudinary.com/dhcti0lrk/image/upload/v1602709289/Group_122_pzjifh.png',
      assignment_types: [1, 6, 7, 10],
      done: false
    };
  },
  methods: {
    setHeaders () {
      const token = document.querySelector('meta[name="csrf-token"]').getAttribute("content")
      axios.defaults.headers["x-csrf-token"] = token
      axios.defaults.headers.common["Accept"] = "application/json"
      axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest"
    },
    getNameCity(city_id) {
      let city = this.cities.find( city => city.id == city_id)
      if (city != null) {
        return city.name
      } else {
        return ''
      }      
    },
    async save() {
      this.academic_reference.project_id = this.project.id
      const url = '/api/v1/academic_references/'
      if (this.academic_reference.id != null) { // put
        let request = await axios.put(`${url}${this.academic_reference.id}`, { academic_reference: this.academic_reference })
        if (request.status == 200) {
          this.showMessage('Referencia académica editada con exito', 'alert-success')
          this.setAcademicReferenceProjectsArchive()
        } else {
          this.showMessage('No se pudo editar la referencia académica', 'alert-danger')
        }
      } else { // post
        let request = await axios.post(url, { academic_reference: this.academic_reference })
        if (request.status == 201) {
          this.showMessage('Referencia académica creada con exito', 'alert-success')
          this.academic_reference = request.data.academic_reference
          this.setAcademicReferenceProjectsArchive()
          this.academic_references_local.push(request.data.academic_reference)
        } else {
          this.showMessage('No se pudo crear la referencia académica', 'alert-danger')
        }
      }
      this.academicReferenceArchives = null      
    },
    setAcademicReferenceProjectsArchive(){
      if (this.academicReferenceArchives) {
        let projectsArchives = []
        this.academicReferenceArchives.forEach(archive => {
          projectsArchives.push(archive.id)
        });
        axios.put(`set_academic_references_project_archives?academic_reference_id=${this.academic_reference.id}&project_archives=${projectsArchives}`)        
      }      
      this.academic_reference = {}      
    },
    async deleteAcademicReference (academic_reference, index) {
      const url = `/api/v1/academic_references/${academic_reference.id}`
      let request = await axios.delete(url)
      if (request.status == 200) {
        this.academic_references_local = this.academic_references_local.filter( academic_reference_iterator => academic_reference_iterator.id != academic_reference.id )
        this.showMessage('Referencia académica eliminada con exito', 'alert-success')
      } else {
        this.showMessage('No se pudo eliminar la referencia académica', 'alert-danger')
      }
    },
    edit (academic_reference) {
      this.academic_reference = academic_reference
      this.getArchives()
      let academic_type = this.academic_types.find( academic_type => academic_type.name == academic_reference.academic_type )
      if (academic_type != null) {
        this.academic_reference.academic_type = academic_type.id
      }      
    },
    async getArchives(){
      let request = await axios.get(`/get_archives_academic_references?academic_reference_id=${this.academic_reference.id}`)
      if (request.status == 200) {
        this.academicReferenceArchives = request.data.archives
      }
    },
    async checkIfAcademicReferencesContainsArchives () {
      let requests = []
      let check = true
      let textCheck = ''
      await this.academic_references_local.forEach(academic_reference => { requests.push(`/get_archives_academic_references?academic_reference_id=${academic_reference.id}`) });
      await axios.all(requests.map((url) => axios.get(url))).then((responses) => {
        for (let index = 0; index < responses.length; index++) {
          let response = responses[index];
          console.log(`${this.academic_references_local[index].name_institution} - ${response.data.archives.length}` )
          if (response.data.archives.length == 0) {
            textCheck += `Documento de la referencia académica ${this.academic_references_local[index].name_institution} requeridos. `
            check = false
          }
        }
      })
      console.log(`${check} - ${textCheck}`)
      if (check) {
        eventBus.$emit('goToNextTab')
      } else {
        this.showMessage(textCheck, 'alert-danger')
      }
    },
    updateArchives(archives){
      this.academicReferenceArchives = archives
    },
    showMessage(message, typeMessage){
      this.message = message
      this.typeMessage = `alert ${typeMessage}`
      setTimeout(() => this.message = '', 10000)
    },
    setTextButton(){
      if (this.academic_reference.id != null){
        this.textButton = 'Editar'
      } else {
        this.textButton = 'Agregar'
      }
    },
    async getCountries(){
      try {
          let url = '/api/v1/countries'
          let result = await axios.get(url)
          this.countries = result.data.countries
          this.country_id = 1
      } catch (error) {
        console.log(error)
      }
    },
    async getCities(){
      try {
        let url = `api/v1/cities/?country_id=${this.country_id}`
        let result = await axios.get(url)
        this.cities = result.data.cities
       } catch (error) {
         console.log(error)
       }
    },
    async viewFiles(academic_reference){
      if(Object.keys(academic_reference).length > 0){
        let url = `get_archives_by_academic_assignment?academic_reference_id=${academic_reference.id}`
        this.files_by_reference = await axios.get(url)
        this.files_by_reference = this.files_by_reference.data.archives
        this.academic_reference_files = academic_reference
        document.getElementById('modalButton').click()
      }
    },
    async deleteArchive(archiveId,index) {
        this.setHeaders()
        let request = await axios.delete( `/delete_file_of_project?archive_id=${archiveId}`)
        if (request.status == 200) {
          this.showMessage(`Archivo eliminado con éxito`, 'alert-success', 7000)
          this.files_by_reference.splice(index,1)
        }        
      },
    async updateFiles(){
      console.log('Holi')
      if(Object.keys(this.academic_reference_files).length > 0) {
        let url = `get_archives_by_academic_assignment?academic_reference_id=${this.academic_reference_files.id}`
        this.files_by_reference = await axios.get(url)
        this.files_by_reference = this.files_by_reference.data.archives
      }
    }
  },
  filters: {
    levelName: function (value) {
      let level_name = ''
      switch (value) {
        case  0:
          level_name = "Primaria"
          break;
        case  1:
          level_name = "Bachiller"
          break;
        case  2:
          level_name = "Profesional Universitario"
          break;
        case  3:
          level_name = "Técnico Profesional"
          break;
        case  4:
          level_name = "Otro"
          break;
        case  5:
          level_name = "Tecnólogo"
          break;
        case  6:
          level_name = "Especialista"
          break;
        case  7:
          level_name = "Maestria"
          break;
        case  8:
          level_name = "Doctorado"
          break;                                                                                            
        default:
          level_name = ""
          break;
      }
      return level_name
    }
  },
  watch: {
    academic_reference() {
      this.setTextButton()
    },
    country_id(){
      this.getCities()
    }
  },  
  components: {
    'upload-multiple-file': UploadMultipleFile
  },
  async created () {
    eventBus.$on('authorizeNextTabAcademic', dataPassed => {
      if (this.academic_references_local.length >= 1) {
        this.checkIfAcademicReferencesContainsArchives()        
      } else {
        this.showMessage('Debe ingresar mínimo una referencia', 'alert-warning')
      }
    }),
    eventBus.$on('updateArchives', dataPassed => {
      this.updateArchives(dataPassed.archives)
    })        
  },
  mounted () {
    this.getCountries()
    this.assignment_types.forEach(assignment_type_id => {
      let assignment = this.assignments.filter( assignment => assignment.assignment_type_id == assignment_type_id )[0]
      if (assignment != null) {
        if (assignment.status == 4) {
          this.done = true
        } 
        return
      }
    });        
    this.width = screen.width
  },
};
</script>

<style></style>
